function maskValue(value, trailingDigits = 4, character = 'X') {
    const string = String(value);
    const regex = new RegExp(`.(?=.{${trailingDigits}})`, 'g');
    const maskedString = string.replace(regex, character);
    return maskedString;
}
// takes and object masks all the properties in an array of sensitive fields
function maskFields(data, sensitiveFields) {
    const hasSensitiveFields = sensitiveFields && sensitiveFields.length;
    const isObject = typeof data === 'object' && !Array.isArray(data);
    if (!data || !hasSensitiveFields || !isObject) {
        return data;
    }
    /* eslint-disable no-use-before-define */
    return cloneObjectMasked(data, sensitiveFields);
    /* eslint-enable no-use-before-define */
}
function cloneObjectMasked(object, sensitiveFields) {
    return Object.entries(object).reduce((acc, [key, value]) => {
        if (object[key] && sensitiveFields.includes(key)) {
            acc[key] = maskValue(value, 0, '*');
        }
        else if (typeof value === 'object') {
            acc[key] = maskFields(value, sensitiveFields);
        }
        else {
            acc[key] = value;
        }
        return acc;
    }, {});
}
const maskData = (sensitiveFields, data) => {
    if (!sensitiveFields ||
        !sensitiveFields.length ||
        ['OK', 'unknownData', 'No Content', 'Not Found', ''].includes(data)) {
        return data;
    }
    return JSON.stringify(maskFields(JSON.parse(data), sensitiveFields));
};

export { maskData };
